import { DateValue } from '@mantine/dates';

import { IBooking, IOwner } from '@/shared/types/booking.types.ts';

import { IPerson } from './person.types';

export type BookingType =
	| 'work_place'
	| 'parking_place'
	| 'meeting_room'
	| 'terminal'
	| 'work_park'
	| 'location';

export enum BookingObjectKinds {
	location = 0,
	parking_place = 1,
	work_place = 2,
	work_object = 3,
	meeting_room = 4,
	terminal = 5,
	work_park = 6,
}

export interface IObjectsResponseType {
	objects: IObject[];
	total: number;
}

export interface IAvailableObjects {
	for_person_id: number;
	location_id: number;
	for_booking_from: Date;
	for_booking_till: Date;
	// object_types_availible_for_booking: ObjectTypesAvailibleForBooking[];
	booking_objects: IBookingObjects[];
}

export interface IObjectsResponseType {
	objects: IObject[];
	total: number;
}

export interface IObject {
	is_available_for_person: boolean;
	is_available_for_moderation: boolean;
	attributes: Record<string, string>;
	name: string;
	id: number;
	description: string;
	is_blocked: boolean;
	type_id: number;
	type: IObjectType;
	parent_id: number;
	parent: IObjectParent;
	booking_pass_type_id: number;
	booking_pass_type: IBookingPassType;
	for_moderator_only: boolean;
	utc_offset: string;
	bookings: IBooking[];
	children: IObject[];
	change_history_list: [];
	owner_person_id?: number;
	owner_change_date?: DateValue;
	moderator_pass_type_id: number;
	svg: string;
	order_column?: number | null;
}

export interface IObjectParent {
	name: string;
	description: string;
	is_blocked: boolean;
	image_id: number;
	svg: string;
	parent_id: number;
	for_moderator_only: boolean;
	utc_offset: string;
	id: number;
	is_deleted: boolean;
	parent?: IObjectParent;
}

export interface IObjectType {
	name: string;
	description: string;
	is_communal: boolean;
	is_bookable: boolean;
	need_a_key: boolean;
	id: number;
	kind: BookingType;
}

export interface IBookingPassType {
	name: string;
	kind: string;
	id: number;
}

export interface IBookingObjects extends IObject {
	booking_status: string;
	free_for_booking_time_percent: number;
	svg: string;
	moderator_pass_type_id: number;
	max_booking_date: string;
	booked_time_slots: [];
	is_deleted: boolean;
	owner_person: IOwner;
	is_external: boolean;
}

export interface IObjectLoad {
	places: {
		work_place?: IObjectPlace;
		parking_place?: IObjectPlace;
		meeting_room?: IObjectPlace;
		work_park?: IObjectPlace;
		terminal?: IObjectPlace;
		location?: IObjectPlace;
	};
}

export interface IObjectPlace {
	free: number;
	free_objects: IObject[];
	booked: number;
	booked_objects: IObject[];
	total: number;
}

export type TBookingObjectFetchType = 'all' | 'favourite' | 'avaliable';

export interface IBookingAvaliableObjects {
	work_place?: IAvaliableObjectsByType;
	parking_place?: IAvaliableObjectsByType;
	meeting_room?: IAvaliableObjectsByType;
	work_park?: IAvaliableObjectsByType;
	terminal?: IAvaliableObjectsByType;
	location?: IAvaliableObjectsByType;
}

export interface IAvaliableObjectsByType {
	objects: IAvaliableObject[];
	total: number;
}

export interface IAvaliableObject extends IBookingObjects {
	relations: IRelation[];
}

export interface IRelation {
	booking_object_id: number;
	id: number;
	person_id: number;
	relation: 'favourite';
}

export interface IObjectRequest {
	name: string;
	description: string;
	is_blocked: boolean;
	type_id: number;
	parent_id: number;
	svg: string;
	id: number;
	for_moderator_only: boolean;
	owner_person_id?: number;
	owner_change_date?: DateValue;
	booking_pass_type_id: number;
	moderator_pass_type_id: number;
	order_column: number | null;
}

export interface IObjectActions {
	kind: string;
	is_deleted: boolean;
	id: number;
	execution_date: string;
	booking_object_id: number;
	assigned_person_id: number;
	assigned_person: IPerson;
}

export interface IObjectActionsResponce {
	objects: IObjectActions[];
	total_amount: number;
}

export interface IAllIObjectsResponse {
	total_amount: number;
	objects: IObject[];
}

export interface IObjectsRequest {
	name: string;
	description: string;
	type_id: number;
	parent_id: number;
}

export interface IBookingObjectType {
	name: string;
	description: string;
	is_communal: boolean;
	is_bookable: boolean;
	id: number;
	kind: string;
	created_at: Date;
	updated_at: Date;
	deleted_at: Date;
	is_deleted: boolean;
}

export interface IBookingObjectTypesResponse {
	objects: IBookingObjectType[];
	total: number;
}

export interface IBookingObjectTypesRequest {
	name: string;
	is_communal: boolean;
	is_bookable: boolean;
	id: number;
	kind: string;
}
